import Head from "next/head";
import { make as LbUnit } from "../../../src/leaderboards/LbUnit.bs";
import { fromUrlName } from "common/src/tft-static/Sd";
import { units } from "common/src/bindings/Translation2";
import { statsSet } from "common/src/Config.ts";

export default function Player({ data, unitId }) {
  return (
    <>
      <Head>
        <title>{`TFT top ${units(unitId)} player leaderboards`}</title>
      </Head>
      <LbUnit key={unitId} data={data} unitId={unitId} />
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

const defUnit = "DA_18_Kennen";
export async function getStaticProps({ params }) {
  let unitId = fromUrlName(params.slug?.[0]) || defUnit;
  if (params && params.slug && params.slug.length > 0) {
    unitId = fromUrlName(params.slug[0], statsSet);
  } else {
    unitId = defUnit;
  }

  if (unitId == null) {
    return {
      notFound: true,
    };
  }

  const resp = await fetch(
    `https://api.tft.tools/unit-leaderboards/${statsSet}/${unitId}`,
  );
  const data = await resp.json();

  return {
    props: {
      data: [data[0], data[1].slice(0, 1000)],
      unitId,
    },
    revalidate: 6000,
  };
}
